import { AxiosRequestConfig } from 'axios'
import { get } from 'lodash'
import {
  fromDoorstepInjectedEnvironment,
  isProduction,
} from '../utilities/environment'
import { DASHER_MOBILE_BFF_ENV_URL } from './constants'

const isProd = isProduction(fromDoorstepInjectedEnvironment(window))

// Can set this value to DASHER_MOBILE_BFF_ENV_URL.PROXY to proxy traffic
// from local web -> production bff
const getDasherMobileBFFUrl = () =>
  isProd
    ? DASHER_MOBILE_BFF_ENV_URL.PRODUCTION
    : DASHER_MOBILE_BFF_ENV_URL.PROXY

const dxApiUrl = (): string | undefined => get(window, 'view.DX_API')

export const bffOpts: AxiosRequestConfig = {
  baseURL: getDasherMobileBFFUrl(),
  headers: { 'content-type': 'application/json; charset=utf-8' },
}

export const opts: AxiosRequestConfig = { baseURL: dxApiUrl() }
